import { useEffect } from "react";
import MainMenu from "../components/MainMenu";
import ViewRules from "../components/ViewRules";
import WorkSpace from "../components/WorkSpace";
import { useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { setAllMappings, getChangesFlag } from "../store/workspaceSlice";
import { useSelector } from "react-redux";
import AccessDenied from "../components/AccessDenied";
import { useBeforeUnload } from "react-router-dom";
const CreateRules = () => {
  const location = useLocation();
  const { user } = useSelector((state) => state.user);
  const { rule } = location.state || {};
  const dispatch = useDispatch();
  const flag = useSelector(getChangesFlag);

  useBeforeUnload(
    flag
      ? (event) => {
          event.preventDefault();
        }
      : undefined,
  );

  useEffect(() => {
    if (rule) {
      dispatch(setAllMappings({ ...rule }));
    }
  }, [rule]);

  const hasCreateAccess =
    user?.role === "super_admin" ||
    user?.projectsAssigned?.some(
      (project) => project?.accessControls?.create === true,
    );

  if (!hasCreateAccess && rule === undefined) {
    return <AccessDenied />;
  }

  return (
    <div className="max-w-[2400px] mx-auto flex">
      <Toaster />
      <div className="w-1/4 bg-gray-100 p-2">
        <h1 className="text-center mt-4 text-xl w-full border-b-2">Tools</h1>
        <MainMenu />
      </div>
      <div className="w-1/2  p-2 overflow-y-scroll h-screen">
        <WorkSpace />
      </div>
      <div className="w-1/4 text-center bg-gray-200">
        <ViewRules />
      </div>
    </div>
  );
};

export default CreateRules;
